import { Fragment } from "react"

const Help = props => {
  return <Fragment>Ayuda</Fragment>
}

export default Help
